// SetActiveMenuItems v1.8
// Sets aria-current on navigation links based on current URL.

// usage:
// setActiveMenuItems(['nav__item'], {
//   matchQueryString: false,
//   postTypeSlugs: ['news', 'insights'],
//   baseUrl: 'https://example.com/',
// });

// changelog:
// 1.0: initial version
// 1.1: navItemClasses parameter required, querystring toggle added
// 1.2: switched active state to aria-current="page"
// 1.3: replaced boolean second parameter with options object
// 1.4: only query anchors that match configured nav classes
// 1.5: rename to SetActiveMenuItems
// 1.6: added optional postTypeSlugs option to avoid global dependency
// 1.7: added optional baseUrl option to avoid global dependency
// 1.8: added matchPartialPath option for active ancestor nav items

const getUrlObject = (url) => {
  try {
    return new URL(url, window.location.href);
  } catch {
    return null;
  }
};

export const setActiveMenuItems = (navItemClasses, options = {}) => {
  if (!Array.isArray(navItemClasses) || navItemClasses.length === 0) {
    throw new TypeError('setActiveMenuItems requires a non-empty navItemClasses array');
  }

  const {
    matchQueryString = false,
    matchPartialPath = false,
    postTypeSlugs = [],
    baseUrl = `${window.location.origin}/`,
  } = options;

  const currentUrl = new URL(window.location.href);
  const cleanUrl = currentUrl.href.split('?')[0].split('#')[0];
  const selector = navItemClasses
    .map(navItemClass => `a.${navItemClass}`)
    .join(', ');
  const navItemsEls = document.querySelectorAll(selector);

  navItemsEls.forEach(navItemEl => {
    navItemEl.removeAttribute('aria-current');
    const href = navItemEl.getAttribute('href');
    if (!href) return;

    const hrefUrl = getUrlObject(href);
    const hrefCleanUrl = hrefUrl ? hrefUrl.href.split('?')[0].split('#')[0] : href;
    const queryMatches = !matchQueryString || (hrefUrl && hrefUrl.search === currentUrl.search);

    // console.log('Comparing:', { href, hrefCleanUrl, cleanUrl, queryMatches });

    if (hrefCleanUrl === cleanUrl && queryMatches) {
      navItemEl.setAttribute('aria-current', 'page');
    } else if (matchPartialPath && hrefCleanUrl !== baseUrl && cleanUrl.startsWith(hrefCleanUrl) && queryMatches) {
      navItemEl.setAttribute('aria-current', 'page');
    } else if (
      Array.isArray(postTypeSlugs)
      && postTypeSlugs.length > 0
    ) {
      for (let j = 0; j < postTypeSlugs.length; j++) {
        if (
          cleanUrl.indexOf('/' + postTypeSlugs[j] + '/') > 0
          && href == baseUrl + postTypeSlugs[j] + '/'
          && queryMatches
        ) {
          navItemEl.setAttribute('aria-current', 'page');
        }
      }
    }
  });
};
